import { Alert, Col, Form, Row, } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import { MazakaTextArea } from "apps/Common/MazakaTextarea";
import useMazakaForm from "hooks/useMazakaForm";
import {  useSearchParams } from "react-router-dom";
import { useGetContractDetails } from "../../ServerSideStates";
import { useEffect } from "react";
import { editContract } from "../../Services";
import { MazakaInput } from "apps/Common/MazakaInput";

const PropertyInfoes = (props: any) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
   const [searchParams,setSearchParams] = useSearchParams()
     const contractId = searchParams.get("contractId");
    const contractDetails = useGetContractDetails(contractId||"")
    useEffect(() => {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set("key", "propertyInfoes");
        return newParams;
      });
    }, []);
  
    useEffect(()=>{
      if(contractDetails?.data?.data)
      {
        form.setFieldsValue({
          ...contractDetails?.data?.data
        })
      }
    },[contractDetails.data])

  const handleOnFinish = async() => {
      mazakaForm.setLoading()
      let formValues = form.getFieldsValue()
      formValues["description"] = formValues["description"]||""
      let contractData = contractDetails?.data?.data
      try {
        const response:any = await editContract({...contractData,...formValues})
        setSearchParams((prev) => {
          const newParams = new URLSearchParams(prev);
          newParams.set("contractId", response?.data?.id);
          return newParams;
        });
        mazakaForm.setSuccess(2000,()=>"İşlem Başarılı")
        props.setSelectedKey("rentalInfoes")
       
      } catch (error:any) {
        mazakaForm.setFailed(2000,error?.message)
      }
  
    };

    const propertyTypeOptions = [
      {label:"Bina",value:0},
      {label:"İş Yeri",value:1},
      {label:"Arsa",value:2},
      {label:"Tarla",value:3},
      {label:"Konut",value:4},
    ]
    
 
  return (
    <>
      <Col span={24}>
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Row gutter={[10, 20]} className="">
          

            <MazakaSelect
              xs={24}
              name={"realEstateType"}
              label={"Taşınmazın Cinsi"}
              className="!m-0"
              placeholder={"Taşınmazın Cinsi"}
              options ={propertyTypeOptions}
              rules={[{required:true,message:""}]}
            />
             <MazakaTextArea
                  xs={24}
                  name={"description"}
                  label={"Açıklama"}
                  className="!m-0"
                  placeholder={"Açıklama"}
                />
            <Col xs={24} className="">
              <Row gutter={[0, 10]}>
                <Col xs={24}>
                  <Alert
                    closable
                    className="!p-4"
                    type="warning"
                    message="Tapu bilgileri alanında ada, parsel, cilt no, sayfa no, yüzölçümü, blok no, giriş kat, bağımsız bölüm no, arsa pay/payda bilgilerini giriniz."
                  />
                </Col>

                <MazakaTextArea
                  xs={24}
                  name={"deedInfo"}
                  label={"Tapu Bilgileri"}
                  className="!m-0"
                  placeholder={"Tapu Bilgileri"}
                  rules={[{required:true,message:""}]}
                />
              </Row>
            </Col>

            <Col span={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                block
                processType={formActions.submitProcessType}
              >
                Kaydet ve Devam Et
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default PropertyInfoes;
